module.exports = __webpack_public_path__ + "e61a71b2d148790392cb2e446e30c5ca.jpg";